import { render, staticRenderFns } from "./revw_overview3.vue?vue&type=template&id=4ce5eac8&scoped=true"
import script from "./revw_overview3.vue?vue&type=script&lang=js"
export * from "./revw_overview3.vue?vue&type=script&lang=js"
import style0 from "./revw_overview3.vue?vue&type=style&index=0&id=4ce5eac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5eac8",
  null
  
)

export default component.exports